import { sei } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createSeiChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createSeiChainCustom({
    client: createClient({ chain: sei, httpRpcs: seiHttpRpcs }),
    explorer: createEtherscanV2({
      name: 'SeiScan',
      baseUrl: 'https://seiscan.io',
      chainId: 1329,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateSeiChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createSeiChainCustom = ({
  client,
  explorer,
}: CreateSeiChainCustomParameters): Chain => ({
  id: 1329,
  network: 'sei',
  name: 'Sei',
  nativeToken: {
    name: 'Sei',
    symbol: 'SEI',
    decimals: 18,
    currency: {
      symbol: 'SEI',
      type: 'CryptoCurrency',
      id: 'sei-network',
      name: 'Sei',
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0xe30fedd158a2e3b13e9badaeabafc5516e95e8c7',
  ]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: 'sei-v2',
  defillamaId: undefined,
})

export const seiHttpRpcs: HttpRpc[] = [
  // Not archive node
  // {
  //   url: 'https://evm-rpc.sei-apis.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 2000n,
  // },
  // Not archive node
  // {
  //   url: 'https://sei.drpc.org',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 2000n,
  // },
  // Not archive node
  // {
  //   url: 'https://sei-evm-rpc.stakeme.pro',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 2000n,
  // },
  // Not archive node
  // {
  //   url: 'https://sei-public.nodies.app',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archive node
  // {
  //   url: 'https://sei.therpc.io',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 2000n,
  // },
  {
    url: 'https://1329.rpc.thirdweb.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://sei.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2000n,
  },
]

export const seiWebsocketRpcUrls: string[] = ['wss://sei.drpc.org']
